import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { changeBody } from '../../modules/tower/towerWriteSlice';
import SizeForm from './editor-components/SizeForm';
import FloorForm from './editor-components/FloorForm';
import CladdingForm from './editor-components/CladdingForm';
import StairForm from './editor-components/StairForm';
import OpeningForm from './editor-components/OpeningForm';
import HoistBeamForm from './editor-components/HoistBeamForm';
import EtcForm from './editor-components/EtcForm';
import { getGrandTotalWeight } from './editor-components/weightSummary';
import UserInputForm from './editor-components/UserInputFormNew';
// import { merge } from 'lodash/fp';  // merge를 사용하지 않으면 기존 값을 덮어쓴다. 다만, 성능상의 비효율이 있다고 한다.

const TowerEditor = ({ onChangeField, title, body, tags, project, user }) => {
    const dispatch = useDispatch();

    const { size, floors, cladding, stair, openings, hoistBeam, etc, userInput, weightSummary } = body;
    const [grandTotalWeight, setGrandTotalWeight] = useState(0);

    /* Tower 이름 입력 */
    const onChangeTitle = (e) => {
        const { name, value } = e.target;
        onChangeField({ key: name, value });
    };

    /* Grand Total 중량 계산하기 */
    // weightSummary에 etc 중량을 넣으면 Main 중량의 %로 계산되는 etc의 특징에 따라 무환반복하는 에러가 발생한다.
    useEffect(() => {
        // const grandTotalWeight = getMainWeight(weightSummary || {}) + getCladdingWeight(weightSummary || {}) + getEtcWeight(etc || {}) + parseFloat(userInput?.weight || '0');
        const grandTotalWeight = getGrandTotalWeight(weightSummary);

        setGrandTotalWeight(grandTotalWeight);
    }, [weightSummary]);

    /* 리덕스에 grandTotal 쓰기 */
    useEffect(() => {

        dispatch(
            changeBody({
                key: 'grandTotal',
                value: grandTotalWeight,
            }),
        );
    }, [dispatch, grandTotalWeight]);

    return (
        <TowerEditorBlock>
            <div className="title-area">
                <label>
                    Tower ID. :{' '}
                    <input
                        style={{
                            fontSize: '1.125rem',
                            border: 'none',
                            outline: 'none',
                            backgroundColor: `${palette.teal[0]}`,
                            padding: '0.25rem 0.5rem',
                        }}
                        placeholder="Input Tower ID"
                        name="title"
                        value={title}
                        onChange={onChangeTitle}
                    />
                </label>
            </div>
            <table>
                <thead>
                    <tr>
                        <th rowSpan={2}>Description</th>
                        <th colSpan={3}>Specification</th>
                        <th colSpan={2}>Q'ty</th>
                        <th style={{ width: '10%' }}>Unit<br/>W't</th>
                        <th style={{ width: '15%' }}>Weight<br/>(kg)</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="spacer"></td>
                    </tr>
                    <SizeForm size={size} />
                    <FloorForm floors={floors} size={size} />
                    <CladdingForm cladding={cladding} size={size} />
                    <StairForm stair={stair} size={size} />
                    <OpeningForm openings={openings} size={size} floors={floors} />
                    <HoistBeamForm hoistBeam={hoistBeam} size={size} />
                    <EtcForm etc={etc} size={size} floors={floors} cladding={cladding} stair={stair} openings={openings} hoistBeam={hoistBeam} />
                    <UserInputForm userInput={userInput} />
                    <tr>
                        <th colSpan={7}>Total Weight of Tower</th>
                        <th className="right-align">{formatDisplayValue(grandTotalWeight)}</th>
                    </tr>
                </tbody>
            </table>
        </TowerEditorBlock>
    );
};

export default TowerEditor;

const TowerEditorBlock = styled.div`
    display: flex;
    flex-direction: column;
    width: 80%;
    min-width: 800px;
    max-width: 1000px;
    box-sizing: border-box;
    margin: 3rem auto;

    .title-area {
        // width: 00px;
        font-size: 1.25rem;
        margin-bottom: 2rem;
    }
    // 테이블 관련 STYLE
    table {
        border-top: 2px solid ${palette.yachtBlue};
        border-bottom: 2px solid ${palette.yachtBlue};
        border-collapse: collapse;
    }
    th {
        border-top: 1px solid ${palette.yachtBlue};
        border-bottom: 1px solid ${palette.yachtBlue};
        padding: 0.5rem 1rem;
    }
    td {
        // border: 1px solid black;
        padding: 0.35rem 1rem;
    }
    .indentation {
        padding-left: 2rem;
    }
    .right-align {
        text-align: right;
    }
    .unit-column {
        width: 40px;
    }
    .input-inside-td {
        padding: 0 0.125rem;
    }
    .sub-description {
        font-size: 0.8rem;
        color: ${palette.gray[8]};
    }
    // 여백
    .spacer {
        padding: 0.5rem 0;
    }
`;

export const Input = styled.input`
    width: 100%;
    background-color: ${palette.teal[0]};
    border: none;
    outline: none;
    box-sizing: border-box;
    padding: 0.25rem 0.5rem;
    text-align: right;
`;

export const Select = styled.select`
    width: 100%;
    background-color: ${palette.teal[0]};
    border: none;
    outline: none;
    box-sizing: border-box;
    padding: 0.25rem 0.5rem;
`;

export const formatDisplayValue = (value) => {
    return isNaN(value) || value === 0 ? '' : value;
};